<template>
    <div class="ReportDetails">
        <!--上面部分-->
        <div class="details_top_wrap">
            <div class="top_nav">
                <p class="nowAddress"><img :src="require('@/common/images/report/address.png')" alt=""> 当前位置：</p>
                <p class="jump_text" @click="toIndex">首页</p>
                <span>></span>
                <p class="jump_text" @click="pageJump(detailsData.firstcode)" v-if="detailsData.firstcodename !== ''">{{detailsData.firstcodename}}</p>
                <span v-if="detailsData.firstcodename !== ''">></span>
                <p class="jump_text" @click="pageJump(detailsData.firstcode, detailsData.secondcode)" v-if="detailsData.secondcodename !== ''">{{detailsData.secondcodename}}</p>
                <span v-if="detailsData.secondcodename !== ''">></span>
                <p>{{detailsData.subject}}</p>
            </div>
            <div class="top_info_wrap">
                <img class="top_bannerImg" :src="detailsData.coverurl" alt="">
                <div class="top_right_wrap">
                    <div class="gary_box">
                        <p class="title">{{detailsData.subject}}</p>
                        <div class="memberTips" @click="handleGoMemberDetails">
                            <div class="iconTips">
                                <img :src="require('@/common/images/course/member_icon.png')" class="memberIcon" alt="">
                                <div class="tips">加入蓝鲸会员享受更多权益！</div>
                            </div>
                            <img :src="require('@/common/images/course/arrow_icon.png')" class="arrowIcon" alt="">
                        </div>
                        <div class="redText">
                            <span class="label">售价</span>
                            <span class="saleprice" v-if="detailsData.feetype === 1">免费</span>
                            <span class="saleprice" v-if="detailsData.feetype === 2 && (!detailsData.zjmemtype || (detailsData.zjmemtype === 2 && detailsData.plusprice == 0))">￥{{ detailsData.saleprice }}</span>
                            <span class="uprice" v-if="detailsData.feetype===2 && detailsData.uprice > 0 && detailsData.uprice > detailsData.saleprice && (!detailsData.zjmemtype || (detailsData.zjmemtype === 2 && detailsData.plusprice == 0))">￥{{detailsData.uprice}}</span>
                            <div class="div_price" v-if="detailsData.feetype === 2 && detailsData.zjmemtype && !user.zjmemtype && detailsData.plusprice > 0">
                                <span class="saleprice">￥{{ detailsData.saleprice }}</span>
                                <img :src="require('@/common/images/course/plus_price_icon1.png')" class="plusPriceIcon1" alt="">
                                <span class="plusPrice">￥{{ detailsData.plusprice }}</span>
                            </div>
                            <div class="div_price" v-if="detailsData.feetype === 2 && detailsData.zjmemtype && user.zjmemtype && detailsData.plusprice > 0">
                                <div class="saleprice">¥{{detailsData.plusprice}}</div>
                                <img :src="require('@/common/images/course/plus_price_icon2.png')" class="plusPriceIcon2" alt="">
                                <span class="plusPrice">原价：￥{{ detailsData.saleprice }}</span>
                            </div>
                        </div>
                        <p><span class="label">报告年份</span><span>{{detailsData.reportyear}}年</span></p>
                        <p><span class="label">所属行业</span><span>{{detailsData.firstcodename}} {{detailsData.secondcodename}}</span></p>
                        <p><span class="label">发布机构</span><span>{{detailsData.hostname}}</span></p>
                    </div>
                    <div class="top_right_bottom">
                        <div class="button_left">
                            <el-button type="danger" v-if="detailsData.feetype===1&&detailsData.isjoin===0" @click="freeGet"><img :src="require('@/common/images/report/free_icon.png')" alt="">免费获取</el-button>
                            <el-button @click="handleGoMemberDetails(1)" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && detailsData.zjmemtype && !user.zjmemtype && detailsData.plusprice > 0" type="openPlus">开通PLUS会员</el-button>
                            <el-button @click="handleGoMemberDetails(2)" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && detailsData.zjmemtype && user.zjmemtype === 1 && detailsData.plusprice > 0" type="upgrade">升级蓝鲸年卡</el-button>
                            <el-button @click="handleGoMemberDetails(2)" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && detailsData.zjmemtype === 2 && detailsData.plusprice == 0" type="upgrade">开通蓝鲸年卡</el-button>
                            <el-button type="danger" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && ((detailsData.zjmemtype && !user.zjmemtype) || (detailsData.zjmemtype === 2 && user.zjmemtype === 1) || (detailsData.zjmemtype === 2 && detailsData.plusprice == 0))" @click="buyNow"><img :src="require('@/common/images/report/buy_icon.png')" alt="">直接购买</el-button>
                            <el-button type="danger" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && (!detailsData.zjmemtype || (detailsData.zjmemtype === 1 && user.zjmemtype === 1) || (detailsData.zjmemtype === 1 && user.zjmemtype === 2))" @click="buyNow"><img :src="require('@/common/images/report/buy_icon.png')" alt="">立即购买</el-button>
                            <!-- <el-button type="warning" v-if="detailsData.ispreview===1&&detailsData.isjoin===0" @click="goPreview"><img :src="require('@/common/images/report/preview_icon.png')" alt="">预览报告</el-button> -->
                            <el-button type="warning" v-if="detailsData.isjoin===1" @click="goPreview"><img :src="require('@/common/images/report/preview_icon.png')" alt="">查看报告</el-button>
                            <a :href="detailsData.fullfileurl" :download="detailsData.fullfileurl" target="_blank">
                                <el-button type="primary"  v-if="detailsData.isdownload===1&&detailsData.isjoin===1"><img :src="require('@/common/images/report/downLoad_icon.png')" alt="">下载报告</el-button>
                            </a>
                        </div>
                        <div class="operation_right">
                            <span class="cursor_class"><img :src="require('@/common/images/report/see.png')" alt="">浏览量 {{detailsData.viewcount}}</span>
                            <span class="line">｜</span>
                            <el-popover
                                    placement="top"
                                    width="106"
                                    trigger="hover">
                                <div class="icon_popover_box">
                                    <div id="qrcodeUrl"></div>
                                    <p>扫码手机分享</p>
                                </div>
                                <span class="icon_box cursor_class" slot="reference">
                                        <img :src="require('@/common/images/other/share_icon.png')" alt="">
                                        <span>分享</span>
                                    </span>
                            </el-popover>
                            <span class="line">｜</span>
                            <!--<span  class="cursor_class enshrine"><img :src="require('@/common/images/other/n_enshrine.png')" alt="">添加收藏</span>-->
                            <span class="cursor_class" @click="collectionClick(detailsData.isfavorite)"  :class="detailsData.isfavorite === 1 ? 'is_enshrine':'enshrine'">
                                <img  :src="detailsData.isfavorite === 1 ? require('@/common/images/other/y_enshrine.png') : require('@/common/images/other/n_enshrine.png')" alt="">{{detailsData.isfavorite === 0 ? '添加' : '取消'}}收藏
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--下面部分-->
        <div class="details_bottom_wrap">
            <!--左侧-->
            <div class="tab_left_box">
                <div class="report_info_wrap">
                    <div class="tab_item">
                        <div @click="menuClick(1)" :class="menuIndex === 1 ? 'active' : ''">报告简介</div>
                        <div @click="menuClick(2)" :class="menuIndex === 2 ? 'active' : ''">报告目录</div>
                    </div>
                    <!--报告简介-->
                    <div v-show="menuIndex === 1" class="introduce_wrap" data-mcs-theme="dark">
                        <div class="no_data_box" v-if="detailsData.repintro===''">
                            <img :src="require('@/common/images/report/no_dataImg.png')" alt="">
                            <span>当前暂无报告简介</span>
                        </div>
                        <div class="introduce_box" v-else v-html="detailsData.repintro"></div>
                    </div>
                    <!--报告目录-->
                    <div  v-show="menuIndex === 2" class="introduce_wrap" data-mcs-theme="dark">
                        <div class="no_data_box" v-if="detailsData.repdirectory===''">
                            <img :src="require('@/common/images/report/no_dataImg.png')" alt="">
                            <span>当前暂无报告目录</span>
                        </div>
                        <div class="introduce_box" v-else v-html="detailsData.repdirectory"></div>
                    </div>
                </div>
                <!--评论-->
                <div class="report_comment_wrap">
                    <p class="title">发表评论</p>
                    <div class="comment_box">
                        <el-input type="textarea" placeholder="快来说说您的看法吧…" v-model="content" maxlength="300"></el-input>
                        <div class="comment_tips">
                            <div class="left_text">
                                <span>只有获取或购买过该报告的用户才能进行评论哦！</span>
                                <span>{{content.length}}/300</span>
                            </div>
                            <el-button type="primary" class="submit_box" @click="submitComment">
                                <img :src="detailsData.isjoin===1 ? require('@/common/images/report/noLock.png') : require('@/common/images/report/lock.png')" alt="">
                                <span>发表评论</span>
                            </el-button>
                        </div>
                    </div>
                    <p class="title">评论区</p>
                    <div class="comment_list" v-show="commentList.length>0" data-mcs-theme="dark">
                        <div class="comment_list_item" v-for="(item,index) in commentList" :key="index">
                            <div class="comment_info">
                                <img :src="item.customeratturl" alt="">
                                <span class="name">{{item.customername}}</span>
                                <span class="date">{{item.datetime}}</span>
                            </div>
                            <div class="comment_main">{{item.content}}</div>
                        </div>
                    </div>
                    <div style="color: #666" v-show="commentList.length<1">暂无评论哦，快来评论一下吧！</div>
                    <div v-show="commentList.length > 0" class="page_box evaluate_page_box">
                        <el-pagination background layout="prev, pager, next" :page-size="5" :total="commentPageTotal"  @current-change="pfPage"></el-pagination>
                    </div>
                </div>
            </div>
            <!--右侧-->
            <div class="tab_right_box">
                <div class="tab_item">
                    <span>相关报告</span>
                    <span class="refresh" @click="refreshClick"><img :src="require('@/common/images/report/refresh_icon.png')" alt="">换一批</span>
                </div>
                <div class="report_list">
                    <div class="report_list_item" v-for="(item,index) in reporList" :key="index" @click="reportClick(item.reportid)">
                        <span class="reportBg"><img :src="item.coverurl" alt=""></span>
                        <span>{{item.subject}}</span>
                        <span class="line"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters,mapActions} from 'vuex'
    import {getReportDetail,getRelatedReport,getCommentList,updateCommentInfo,updateJoinReport} from 'api/reportApi'
    import {uploadCourseFavorite} from 'api/api'
    import $ from 'jquery'
    import QRCode  from "qrcodejs2"
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
    export default {
        name: "ReportDetails",
        data() {
            return {
                menuIndex: 1, //导航
                content:'', //评价内容
                detailsData:{}, //报告详情
                reporList:[], //相关报告
                commentList:[], //评论列表
                commentPageTotal: 0, // 评论全部页码
            }
        },
        created() {
            if(this.domainInfo.isMobile){
                this.$router.push({
                    name: 'MReportDetails',
                    query: {'reportid': this.$route.query.reportid, chid: this.$route.query.chid ? this.$route.query.chid : ''}
                })
            }
        },
        mounted() {
            $('.comment_list').mCustomScrollbar();
            this._getDetails();
            this._getRelatedReport();
            this._getCommentList(1)
            this.qRCode()
        },
        methods: {
            // 页面跳转
            toIndex() {
                this.$router.push({name: 'ReportIndex'})
            },
            pageJump(code, code2) {
                if (code2) {
                    this.$router.push({name: 'ReportSearch', query: {catecode: code, typeData: code2}})
                } else {
                    this.$router.push({name: 'ReportSearch', query: {catecode: code}})
                }
            },
            // 导航点击
            menuClick(val) {
                this.menuIndex = val;
            },
            // 分享二维码生成
            qRCode() {
                new QRCode('qrcodeUrl', {
                    width: 100,
                    height: 100, // 高度
                    text: window.location.origin+'/m/MReportDetails?reportid='+this.$route.query.reportid,   // 二维码内容
                })
            },
            // 获取详情信息
            _getDetails(){
                this.setLoading(true);
                let params = {
                    reportid: this.$route.query.reportid,
                    channelid: this.$route.query.chid ? this.$route.query.chid : ''
                };
                getReportDetail({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.detailsData = data.data;
                        if(this.detailsData.repintro!==''||this.detailsData.repdirectory!==''){
                            $('.introduce_wrap').mCustomScrollbar();
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 收藏报告
            collectionClick(val) {
                this.setLoading(true);
                let params = {
                    courseid: this.$route.query.reportid,
                    optype: val === 1 ? 2 : 1,
                    kmctype: 2,
                }
                uploadCourseFavorite({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        if (data.code === '000') {
                            if (val === 1) {
                                this.detailsData.isfavorite = 0
                                this.$message.success('已取消收藏')
                            } else {
                                this.detailsData.isfavorite = 1
                                this.$message.success('收藏成功')
                            }
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 获取相关报告
            _getRelatedReport(){
                this.setLoading(true);
                let params = {
                    reportid: this.$route.query.reportid,
                    channelid: this.$route.query.chid ? this.$route.query.chid : ''
                };
                getRelatedReport({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.reporList = data.data.reportinfo;
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 相关报告点击
            reportClick(id){
                this.$router.push({name: 'ReportDetails', query: {'reportid': id, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
            },
            // 获取评论列表
            _getCommentList(val){
                this.setLoading(true);
                let params = {
                    reportid: this.$route.query.reportid,
                    page:val,
                    pageSize:5
                };
                getCommentList({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.commentList = data.data.content;
                        this.commentPageTotal = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 评论分页
            pfPage(){
                let clickPage = $(".evaluate_page_box .el-pagination .active").html()
                this._getCommentList(clickPage)
            },
            // 提交用户评价
            submitComment(){
                // console.log(this.user)
                if(this.detailsData.isjoin===1){
                    this.setLoading(true);
                    let params = {
                        reportid: this.$route.query.reportid,
                        content:this.content
                    };
                    updateCommentInfo({
                        data: Object.assign({}, params),
                        success: data => {
                            console.log(data);
                            this.setLoading(false);
                            this.$message.success('评论成功');
                            this.content='';
                            this._getCommentList(1)
                        },
                        error: data => {
                            this.$message.error(data.msg)
                        }
                    })
                }else{
                    if(this.user.isLogin===true){
                        this.$message({
                            message: '您当前不能发表评论',
                            type: 'warning'
                        });
                    }else{
                        this.setLoginPop(true)
                    }
                }
            },
            // 换一批
            refreshClick(){
                this._getRelatedReport()
            },
            // 免费获取
            freeGet(){
                this.setLoading(true);
                let params = {
                    reportid: this.$route.query.reportid,
                    channelid: this.$route.query.chid ? this.$route.query.chid : ''
                };
                updateJoinReport({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.$message.success('你已获取成功！');
                        this._getDetails()
                        // this.detailsData.isjoin=1
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 去会员详情页面 zjmemtype: 1为PLUS卡 2为年卡
            handleGoMemberDetails(zjmemtype) {
                console.log(zjmemtype)
                this.$router.push({name: 'MemberDetails', query: {chid: this.$route.query.chid ? this.$route.query.chid : ''}})
            },
            // 立即购买
            buyNow() {
                if(this.user.isLogin===true){
                    // this.$router.push({name: 'OrderIndex', query: {'reportid': this.detailsData.reportid, kmctype: 2}})
                    this.$router.push({name: 'OrderIndex', query: {'kmcinnerid': this.detailsData.reportid, kmctype: 2}})
                }else{
                    this.setLoginPop(true)
                }
            },
            // 预览报告
            goPreview(){
                if(this.user.isLogin===true){
                    // 查看
                    if(this.detailsData.isjoin===1){
                        let {href} = this.$router.resolve({
                            name: 'ReportPreview', query: {'reportid': this.detailsData.reportid,retype:1}
                        })
                        window.open(href, '_blank')
                        // this.$router.push({name: 'ReportPreview', query: {'reportid': this.detailsData.reportid,retype:1}})
                    }else{  // 预览
                        let {href} = this.$router.resolve({
                            name: 'ReportPreview', query: {'reportid': this.detailsData.reportid,retype:2}
                        })
                        window.open(href, '_blank')
                        // this.$router.push({name: 'ReportPreview', query: {'reportid': this.detailsData.reportid,retype:2}})
                    }
                }else{
                    this.setLoginPop(true)
                }
            },
            // 回到顶部
            goTop() {
                $("html,body").animate({
                    scrollTop: 0
                }, 400)
            },
            ...mapActions([
                'setLoading',
                'setLoginPop',
                'setUser'
            ])
        },
        watch: {
            $route: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.menuIndex = 1
                    this.detailsData = {}
                    this.commentList=[]
                    this._getDetails()
                    this._getCommentList(1)
                    this.goTop()
                }
            },
            user: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.menuIndex = 1
                    this.detailsData = {}
                    this.commentList=[]
                    this._getDetails()
                    this._getCommentList(1)
                    this.goTop()
                }
            }
        },
        computed: {
            ...mapGetters(['loginPop', 'user','domainInfo'])
        },
        components: {
        }
    }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .ReportDetails{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        color: #333;
        height: 100%;
        .details_top_wrap{
            padding: 0px 0 30px 0;
            width: 1200px;
            box-sizing: border-box;
            margin: 0 auto;
            .top_nav {
                padding-bottom: 30px;
                display: flex;
                align-items: center;
                .nowAddress{
                    display: flex;
                    align-items: center;
                    img{
                        margin-right: 5px;
                        vertical-align: middle;
                    }
                }
                .jump_text {
                    cursor: pointer;
                }
                .jump_text:hover {
                    color: #409EFF;
                }
                span {
                    margin: 0 8px;
                }
            }
            .top_info_wrap{
                display: flex;
                justify-content: space-between;
                .top_bannerImg{
                    width:458px;
                    min-width: 458px;
                    height:275px;
                    border-radius: 4px;
                }
                .top_right_wrap{
                    margin-left:20px;
                    width:100%;
                    .gary_box{
                        height:auto;
                        background:#f9f9f9;
                        padding: 20px 0 10px 0;
                        .title{
                            font-size: 20px;
                            line-height: 28px;
                            margin-bottom: 5px;
                        }
                        .memberTips {
                            margin-left: 20px;
                            margin-bottom: 15px;
                            height: 28px;
                            width: 340px;
                            background: #FFF7DF;
                            border-radius: 2px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 10px;
                            box-sizing: border-box;
                            cursor: pointer;
                            .iconTips {
                                display: flex;
                                align-items: center;
                                .memberIcon {
                                    width: 14px;
                                    height: 14px;
                                    margin-right: 5px;
                                }
                                .tips {
                                    font-size: 12px;
                                    color: #7A6544;
                                }
                            }
                            .arrowIcon {
                                width: 5px;
                                height: 9px;
                            }
                        }
                        .redText{
                            color: #F56C6C;
                            margin-bottom: 10px;
                            padding: 0 20px;
                            display: flex;
                            align-items: flex-end;
                            .label{
                                margin-right: 22px;
                                width: 60px;
                                display: inline-block;
                                text-align-last: justify;
                            }
                            .uprice{
                                color: #666666;
                                margin-left: 5px;
                                text-decoration: line-through;
                            }
                            .div_price {
                                display: flex;
                                align-items: center;
                                .saleprice {
                                    color: #FF4747FF;
                                    font-size:20px;
                                }
                                .plusPriceIcon1 {
                                    width: 65px;
                                    height: 19px;
                                    margin: 0 5px 0 8px;
                                    // display: inline-block;
                                    // position: relative;
                                    // top: 1px;
                                }
                                .plusPriceIcon2 {
                                    width: 48px;
                                    height: 19px;
                                    margin: 0 5px 0 8px;
                                }
                                .plusPrice {
                                    font-size: 14px;
                                    color: #666666;
                                }
                            }
                        }
                        p{
                            padding: 0 20px;
                            line-height: 20px;
                            &:not(:last-of-type) {
                                margin-bottom: 5px;
                            }
                            .label{
                                margin-right: 22px;
                                width: 60px;
                                display: inline-block;
                                text-align-last: justify;
                            }
                        }
                        p:last-child{
                            padding-bottom: 0;
                            margin-bottom: 8px;
                        }
                        .saleprice{
                            font-size: 20px;
                        }
                    }
                    .top_right_bottom{
                        display: flex;
                        justify-content: space-between;
                        margin-top: 22px;
                        .button_left{
                            display: flex;
                            .el-button--warning{
                                background-color: #FFA904;
                                border-color: #FFA904;
                            }
                            .el-button--warning:focus, .el-button--warning:hover {
                                background: #ebb563;
                                border-color: #ebb563;
                            }
                            .el-button {
                                width: 130px;
                                margin-right: 20px;
                                padding: 8px;
                                &>span {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    font-size: 16px;
                                    line-height: 22px;
                                    &>img {
                                        width: 18px;
                                        height: 18px;
                                        margin-right: 8px;
                                    }
                                }
                                &.el-button--openPlus {
                                    background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                                    color: #FFE0AF;
                                    border: none;
                                    &:hover, &:active {
                                        background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                                        color: #FFE0AF;
                                    }
                                }
                                &.el-button--upgrade {
                                    background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                                    color: #ffffff;
                                    border: none;
                                    &:hover, &:active {
                                        background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                                        color: #ffffff;
                                    }
                                }
                            }
                        }
                        .operation_right{
                            display: flex;
                            align-items: center;
                            span {
                                color: #999;
                                white-space: nowrap;
                            }
                            .line {
                                color: #e5e5e5;
                                margin: 0 10px;
                            }
                            .cursor_class {
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                & > img {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 4px;
                                }
                            }
                            .is_enshrine{
                                color: #409EFF;
                            }
                        }
                    }
                }
            }

        }
        .details_bottom_wrap{
            height: 100%;
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
            /*左侧选项卡*/
            .tab_left_box {
                width: 100%;
                .report_info_wrap{
                    width: 100%;
                    height: auto;
                    border:1px solid rgba(229,229,229,1);
                    max-height: 600px;
                    .tab_item{
                        height: 48px;
                        display: flex;
                        align-items: center;
                        background:rgba(245,245,245,1);
                        & > div {
                            width: 120px;
                            height: 48px;
                            line-height: 48px;
                            text-align: center;
                            position: relative;
                            box-sizing: border-box;
                            cursor: pointer;
                            font-size: 16px;
                            font-weight: bold;
                            color: #333;
                            -moz-user-select: none; /* Firefox私有属性 */
                            -webkit-user-select: none; /* WebKit内核私有属性 */
                            -ms-user-select: none; /* IE私有属性(IE10及以后) */
                            -khtml-user-select: none; /* KHTML内核私有属性 */
                            -o-user-select: none; /* Opera私有属性 */
                            user-select: none; /* CSS3属性 */
                            & > span, & > label {
                                font-size: 10px;
                                color: #999;
                                line-height: 14px;
                                position: absolute;
                                top: -4px;
                                left: 66px;
                            }
                            & > label {
                                color: #FFF;
                                text-align: center;
                                padding: 2px 5px;
                                white-space: nowrap;
                                background-color: #FF4747FF;
                                border-radius: 10px;
                                top: -6px;
                            }
                        }
                        & > div:hover {
                            color: #409EFFFF;
                        }
                        & > div::before {
                            content: '';
                            width: 1px;
                            height: 20px;
                            background-color: rgba(229, 229, 229, 1);
                            position: absolute;
                            bottom: 6px;
                            right: -46px;
                        }
                        & > div:nth-last-of-type(1)::before {
                            width: 0;
                            height: 0;
                        }
                        .active {
                            color: #409EFFFF;
                            background: #fff;
                        }
                        .active::after {
                            content: '';
                            width: 100%;
                            height: 3px;
                            background-color: #409EFF;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                    }
                    .introduce_wrap{
                        height: auto;
                        /*max-height: 550px;*/
                        min-height: 550px;
                        max-height: 450px;
                        position: relative;
                        overflow-y: auto;
                        .introduce_box {
                            padding: 20px;
                            line-height: 28px;
                            * {
                                font-size: 14px;
                                max-width: 100%;
                                line-height: 28px;
                            }
                        }
                        .no_data_box {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                            & > img {
                                width: 90px;
                                height: 75px;
                                margin-bottom: 20px;
                            }
                            & > span {
                                color: #CADAEEFF;
                                line-height: 20px;
                            }
                        }
                    }
                }
                .report_comment_wrap{
                    .title{
                        font-size: 16px;
                        margin: 30px 0;
                    }
                    .comment_box{
                        .el-textarea__inner{
                            height: 150px;
                            padding: 10px;
                            resize: none;
                        }
                        .comment_tips{
                            height: 50px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            background:rgba(229,229,229,1);
                            .left_text{
                                min-width: 790px;
                                display: flex;
                                justify-content: space-between;
                                padding: 0 10px;
                                color: #666;
                            }
                            .el-button {
                                border-radius: 0;
                                height: 50px;
                                &>span {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    &>img {
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 5px;
                                    }
                                }
                            }
                        }
                    }
                    .comment_list{
                        max-height: 570px;
                        overflow-y: auto;
                        .comment_list_item{
                            border-bottom: 1px solid #E5E5E5;
                            margin-top: 20px;
                            .comment_info{
                                display: flex;
                                align-items: center;
                                img{
                                    width: 52px;
                                    height: 52px;
                                    border-radius: 50%;
                                    background: gray;
                                    display: inline-block;
                                }
                                span{
                                    margin-left: 20px;
                                    font-size: 16px;
                                    color: #333;
                                }
                                .date{
                                    font-size: 14px;
                                    color: #999;
                                }
                            }
                            .comment_main{
                                margin-left: 70px;
                                line-height: 22px;
                                padding-bottom: 20px;
                                word-break: break-all;
                            }
                        }
                    }
                    .page_box {
                        display: flex;
                        justify-content: center;
                        padding-top: 20px;
                    }
                }
            }
            .tab_right_box{
                min-width: 260px;
                width: 260px;
                margin-left: 30px;
                .tab_item{
                    height: 48px;
                    display: flex;
                    align-items: center;
                    background:rgba(245,245,245,1);
                    justify-content: space-between;
                    padding: 0 10px;
                    border: 1px solid #e5e5e5;
                    border-bottom: none;
                    .refresh{
                        color: #999;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 5px;
                        }
                    }
                    span:first-child{
                        font-size: 16px;
                        color: #333;
                    }
                }
                .report_list{
                    border:1px solid rgba(229,229,229,1);
                    border-top: none;
                    .report_list_item:first-child{
                        padding-top: 20px;
                    }
                    .report_list_item:last-child{
                        padding-bottom: 20px;
                    }
                    .report_list_item:last-child .line{
                        display: none;
                    }
                    .report_list_item{
                        padding: 0 20px;
                        cursor: pointer;
                        .reportBg{
                            display: block;
                            width: 100%;
                            height: 120px;
                            background-image: url('./../../../common/images/report/reportBg.png');
                            background-size: 100%;
                            overflow: hidden;
                            margin-bottom: 12px;
                            img{
                                width:212px;
                                height:126px;
                            }
                        }
                        span{
                            line-height: 22px;
                            display: inline-block;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                            overflow: hidden;
                        }
                        .line{
                            width: 100%;
                            height: 1px;
                            background: #E5E5E5;
                            margin: 20px 0;
                        }
                    }
                }
            }
        }
    }
    .icon_popover_box {
        #qrcodeUrl{
            margin-bottom: 6px;
        }
    }
    /*滚动条样式*/
    .mCS-dark.mCSB_scrollTools .mCSB_draggerRail{
        background-color: #fff;
    }
    .mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{
        background-color: #ccc !important;
    }
    /*.mCSB_scrollTools .mCSB_dragger{*/
        /*height: 80px!important;*/
    /*}*/
    /*.comment_list::-webkit-scrollbar,.introduce_wrap::-webkit-scrollbar {!*滚动条整体样式*!*/
        /*width:8px;*/
        /*background:rgba(204,204,204,1);*/
        /*border-radius:6px;*/
    /*}*/
    /*.comment_list::-webkit-scrollbar-thumb {!*滚动条里面小方块*!*/
        /*border-radius: 6px;*/
        /*!*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*!*/
        /*background:#fff;*/
    /*}*/
    /*.comment_list::-webkit-scrollbar-track {!*滚动条里面轨道*!*/
        /*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
        /*border-radius: 0;*/
        /*background:#fff;*/
    /*}*/

</style>